
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class DownloadButton extends Vue {
  @Prop({ default: null }) readonly url!: string | null;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ default: 'Descargar' }) readonly tooltip!: string;
  @Prop({ default: 'mdi-download' }) readonly icon!: string;
  @Prop({ type: Boolean, default: false }) readonly light!: boolean;

  get hasUrl(): boolean {
    return !!(this.url && typeof this.url === 'string' && this.url.length > 0);
  }

  onClick() {
    if (this.disabled || !this.hasUrl) return;
    window.open(this.url as string, '_blank');
  }
}
